const HTTP_PROTOCOL_REGEX = /^https?:\/\//;
export const addMissingProtocolToUrl = url => {
  if (HTTP_PROTOCOL_REGEX.test(url)) {
    return url;
  }
  return `http://${url}`;
};